var map = {
	"./email-otp.js": "D8lJ",
	"./email.js": "OuLO",
	"./index.js": "bXuT",
	"./otp-form.js": "11FI",
	"./phone-otp.js": "ojIE",
	"./phone.js": "eL0u"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4Jp9";